export const stateName = 'next-env';